import React from 'react';
import PropTypes from 'prop-types';
import { Label, Item, ItemContainer, CheckboxContainer, BodyContainer, Title, Box, SubTitle } from './style';
import { Checkbox } from '../../../../atoms/Input/Checkbox';
export var Body = function Body(props) {
  var min = '';
  var max = '';

  if (props.range.current.length) {
    min = props.range.current[0].toDate().toLocaleDateString();
    max = props.range.current[1].toDate().toLocaleDateString();
  } else {
    min = props.range.total[0].toDate().toLocaleDateString();
    max = props.range.total[1].toDate().toLocaleDateString();
  }

  return React.createElement(BodyContainer, null, React.createElement(Title, null, "".concat(props.label, ":")), props.resolution && props.resolution.available && props.resolution.available.length ? React.createElement(SubTitle, null, "Select data resolution:", props.error ? React.createElement(SubTitle, {
    color: 'red',
    small: true
  }, "Select data resolution!") : React.createElement(SubTitle, null)) : React.createElement(SubTitle, null), React.createElement(ItemContainer, null, props.resolution ? props.resolution.available.map(function (id) {
    return React.createElement(Item, {
      key: id
    }, React.createElement(CheckboxContainer, {
      key: id,
      onClick: function onClick() {
        props.toggleItem(id);
      }
    }, React.createElement(Checkbox, {
      color: '#9de042',
      checked: props.checkbox.resolution[id]
    })), React.createElement(Label, null, id));
  }) : ''), React.createElement(SubTitle, null, "Selected data range:"), React.createElement(ItemContainer, null, React.createElement(Box, null, "".concat(min, " - ").concat(max))));
};
Body.propTypes = {
  checkbox: PropTypes.object,
  resolution: PropTypes.object,
  range: PropTypes.object,
  error: PropTypes.bool,
  label: PropTypes.string,
  toggleItem: PropTypes.func
};